import { Grid, makeStyles, MenuItem } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/Button/Button';
import TextInput from 'components/TextInput/TextInput';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserAdminBusinessIds } from 'scenes/Permissions/store/selectors/base-project-permissions.selectors';
import { closeJoinEmployeeToProjectDialog } from 'store/projectUsers/actions/project-users.actions';
import {
  selectCurrentUserEmployerProjects,
  selectIsJoiningEmployeeToProject,
  selectUserAdminBusinessResources,
} from 'store/resources/selectors/resources.selectors';
import { joinExistingEmployeeToProject } from 'store/resources/thunks/joinExistingEmployeeToProject.thunk';

import Loading from 'components/Loading/Loading';
import { uniqBy } from 'lodash';
import { selectWorkCalendarProjectsArray } from 'scenes/WorkDemo/store/selectors/workSelectorsDemo';
import { selectProjectsArray } from 'store/projects/selectors/projectsSelectors';

export const JoinExistingEmployeeToProjectDialog = ({ projectId }) => {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      ...theme.component.dialogPaper,
      [theme.breakpoints.down('xs')]: {
        ...theme.component.dialogPaperFullscreen,
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(2),
    },
    dialogActions: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  }));

  const isJoiningEmployeeToProject = useSelector(
    selectIsJoiningEmployeeToProject
  );

  const workCalendarProjects = useSelector(selectWorkCalendarProjectsArray);
  const projects = useSelector(selectProjectsArray);

  const projectToJoin = [...workCalendarProjects, ...projects].find(
    (project) => project.id === projectId
  );

  const dispatch = useDispatch();

  const classes = useStyles();

  const { t } = useTranslation('common');

  const onConfirm = () => {
    dispatch(
      joinExistingEmployeeToProject({
        projectId,
        userId: selectedUserId,
        employerBusinessId: selectedEmployerBusinessId,
      })
    );
  };

  const close = () => {
    dispatch(closeJoinEmployeeToProjectDialog());
  };

  const [selectedUserId, setSelectedUserId] = useState('');

  const employeeResources = useSelector(selectUserAdminBusinessResources);

  const userEmployers = useSelector(selectCurrentUserEmployerProjects);

  const userAdminBusinessIds = useSelector(selectUserAdminBusinessIds);

  const [selectedEmployerBusinessId, setSelectedEmployerBusinessId] =
    useState('');

  const selectedEmployerBusinessResources = employeeResources.filter(
    (resource) => resource.employerBusinessId === selectedEmployerBusinessId
  );

  return (
    <Dialog
      open={true}
      onClose={() => close()}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>{'Liitä työntekijä projektiin'}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            Projekti: {projectToJoin?.name}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              value={selectedEmployerBusinessId || ''}
              onChange={(e) => setSelectedEmployerBusinessId(e.target.value)}
              select
              fullWidth
              style={{ marginRight: '4px' }}
              label={'Työnantaja'}
            >
              {userEmployers
                .filter((employerProject) =>
                  userAdminBusinessIds.includes(employerProject.business_id)
                )
                .map((option, index) => (
                  <MenuItem key={index} value={option.business_id}>
                    {`${option.name}`}
                  </MenuItem>
                ))}
            </TextInput>
          </Grid>
          <Grid item xs={12}>
            <TextInput
              value={selectedUserId || ''}
              onChange={(e) => setSelectedUserId(e.target.value)}
              select
              fullWidth
              style={{ marginRight: '4px' }}
              label={'Työntekijä'}
              disabled={!selectedEmployerBusinessId}
            >
              {uniqBy(selectedEmployerBusinessResources, 'user').map(
                (option, index) => (
                  <MenuItem key={index} value={option.user}>
                    {`${option.firstName} ${option.lastName}`}
                  </MenuItem>
                )
              )}
            </TextInput>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()}>{t('common.cancel')}</Button>
        <Button
          disabled={
            !selectedEmployerBusinessId ||
            !selectedUserId ||
            isJoiningEmployeeToProject
          }
          color="primary"
          variant="contained"
          onClick={() => onConfirm()}
        >
          {isJoiningEmployeeToProject ? (
            <Loading tiny></Loading>
          ) : (
            'Liitä käyttäjä'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
